import { rewardRegularReq, rewardReqWithoutLogin } from "@/utils/request";
///cook-manage-admin/api/h5/card/getUserCards
import { activityId } from "@/views/roki/yearEndOpenBlindBox/data/index";
export function getUserCardApi(params) {
  return rewardRegularReq({
    url: "/cook-manage-admin/api/h5/card/getUserCards",
    method: "get",
    params
  });
}
export function getUserTaskNumApi(params) {
  return rewardRegularReq({
    url: "/cook-manage-admin/api/h5/task/listUserTask",
    method: "get",
    params
  });
} //获取用户当天的任务情况
export function userTaskAddNumApi(data) {
  return rewardRegularReq({
    url: "/cook-manage-admin/api/h5/task/userCompleteTask",
    method: "post",
    data
  });
} //用户完成任务
export function cardComposeApi(params) {
  return rewardRegularReq({
    url: "/cook-manage-admin/api/h5/card/cardsSynthesis",
    method: "get",
    params
  });
}//合成
//   export function initUserLotteryNum(params) {
//     return rewardReqWithoutLogin({
//       url: "/cook-manage-admin/api/ops/activity/lottery/getInfoByUserId",
//       method: "get",
//       params
//     });
//   }
 



// WEBPACK FOOTER //
// ./src/api/openBlind.js